import React, { useEffect, useState } from "react";

const QUESTIONS = [
  "What's the hostel food actually like?",
  "Are the faculty approachable?",
  "What's placement really like?",
  "Is the campus safe at night?",
  "Are the fees worth it?",
  "Which branch has the best placements?",
  "How is the Wi-Fi on campus?",
  "What's the social life like?",
];

export default function Typewriter() {
  const [idx, setIdx] = useState(0);
  const [text, setText] = useState("");
  const [phase, setPhase] = useState("type"); // type | hold | delete

  useEffect(() => {
    let timer;
    const current = QUESTIONS[idx];
    if (phase === "type") {
      if (text.length < current.length) {
        timer = setTimeout(() => setText(current.slice(0, text.length + 1)), 48);
      } else {
        timer = setTimeout(() => setPhase("delete"), 1800);
      }
    } else if (phase === "delete") {
      if (text.length > 0) {
        timer = setTimeout(() => setText(current.slice(0, text.length - 1)), 24);
      } else {
        timer = setTimeout(() => { setIdx((i) => (i + 1) % QUESTIONS.length); setPhase("type"); }, 300);
      }
    }
    return () => clearTimeout(timer);
  }, [text, phase, idx]);

  return <span className="caret">{text}</span>;
}
